<template>
  <!-- La raíz queda en su lugar (Vue la usa de referencia al redibujar el padre); solo la
       barra se muda a <body> (el menú lateral desplaza el contenido con transform). -->
  <span class="m-bottom-nav-anchor">
    <nav ref="nav" class="m-bottom-nav" :aria-label="label">
      <button
        v-for="item in items"
        :key="item.key"
        type="button"
        class="m-bottom-nav__item"
        :class="{ 'is-active': item.active }"
        :aria-current="item.active ? 'page' : null"
        @click="$emit('select', item)"
      >
        <span class="m-bottom-nav__icon">
          <i :class="['fas', 'fa-' + item.icon]" aria-hidden="true"></i>
          <span v-if="item.badge" class="m-bottom-nav__badge">{{
            item.badge
          }}</span>
        </span>
        <span class="m-bottom-nav__label">{{ item.label }}</span>
      </button>
    </nav>
  </span>
</template>

<script>
/**
 * Barra de navegación inferior de la app en el teléfono. items: [{ key, label, icon,
 * active, badge }]; emite «select» con el item. Mientras está montada, <body> lleva
 * `m-has-bottom-nav` para dejarle lugar al contenido y subir el botón «+».
 */
export default {
  name: "MobileBottomNav",
  props: {
    items: { type: Array, default: () => [] },
    label: { type: String, default: "Navigation" },
  },
  mounted() {
    document.body.appendChild(this.$refs.nav);
    document.body.classList.add("m-has-bottom-nav");
  },
  beforeDestroy() {
    document.body.classList.remove("m-has-bottom-nav");
    const nav = this.$refs.nav;
    if (nav && nav.parentNode) nav.parentNode.removeChild(nav);
  },
};
</script>

<style scoped>
.m-bottom-nav-anchor {
  display: none;
}
.m-bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1035; /* sobre el contenido y el «+», debajo de hojas y modales */
  display: flex;
  height: calc(3.6rem + env(safe-area-inset-bottom));
  padding-bottom: env(safe-area-inset-bottom);
  background: var(--m-surface);
  border-top: 1px solid var(--m-border);
}
.m-bottom-nav__item {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  border: 0;
  background: transparent;
  color: var(--m-muted);
  font-size: 0.7rem;
}
.m-bottom-nav__item.is-active {
  color: var(--bs-primary);
  font-weight: 600;
}
.m-bottom-nav__icon {
  position: relative;
  font-size: 1.15rem;
  line-height: 1;
}
.m-bottom-nav__item.is-active .m-bottom-nav__icon::before {
  content: "";
  position: absolute;
  inset: -0.3rem -0.9rem;
  border-radius: 999px;
  background: rgba(var(--bs-primary-rgb), 0.12);
}
.m-bottom-nav__icon i {
  position: relative;
}
.m-bottom-nav__badge {
  position: absolute;
  top: -0.45rem;
  right: -0.75rem;
  min-width: 1.05rem;
  height: 1.05rem;
  padding: 0 0.25rem;
  border-radius: 999px;
  background: var(--bs-danger);
  color: var(--bs-white);
  font-size: 0.62rem;
  font-weight: 600;
  line-height: 1.05rem;
  text-align: center;
}
.m-bottom-nav__label {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
